/**
 * SPM 编码表类型约定。
 *
 * SPM 为四段式位置编码 A.B.C.D：A=品牌×站点，B=页面×终端，C=逻辑模块，D=业务位置。
 * 编码表由 scripts/generate-spm-codes.mjs 从评审清单 CSV 生成，见 codes/ 目录。
 */

/** 单个 C 位模块的编码集合。 */
export const SPM_POSITION_OFFSET = Symbol('SPM_POSITION_OFFSET');
export interface SpmModuleCodes {
  /** 模块编码或模板（A.B.C）。含占位符时须绑定实际值后再上报。 */
  code: string;
  /** 商品列表分页序号偏移，仅由 withProductListPageOffset 设置。 */
  [SPM_POSITION_OFFSET]?: number;
  /** D 位坑位编码 → 完整 SPM（A.B.C.D）。点击事件上报使用。 */
  [positionCode: string]: string;
}

/** 单个页面终端（B 位）的编码表：模块键 → 编码集合；首页楼层键为模板分组名，实际 C 段由 component_id/id 绑定。 */
export type SpmPageCodes = Record<string, SpmModuleCodes>;
